import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { PurchaseHistoryCard } from './PurchaseHistoryCard';
import { PurchaseHistoryCardItem } from './types';

export interface PurchaseHistoryCardListProps {
  items: PurchaseHistoryCardItem[];
  selectedId: string | null;
  onCardClick: (item: PurchaseHistoryCardItem, uniqueKey: string) => void;
  /** 카드 영역(상품) 클릭 시 호출 - PDP 진입용 */
  onProductClick?: (item: PurchaseHistoryCardItem) => void;
  onClose?: () => void;
  title?: string;
  /** 선택 전 버튼 텍스트 (기본값: '비교하기') */
  actionButtonText?: string;
  /** 선택 후 버튼 텍스트 (기본값: '비교 중') */
  selectedButtonText?: string;
  /** 컨테이너 패딩 제거 여부 */
  noPadding?: boolean;
}

export const PurchaseHistoryCardList = ({
  items,
  selectedId,
  onCardClick,
  onProductClick,
  title,
  actionButtonText = '비교하기',
  selectedButtonText = '비교 중',
  noPadding = false,
}: PurchaseHistoryCardListProps) => {
  return (
    <Container noPadding={noPadding}>
      {title && (
        <Header>
          <Title variant='Head_20_Multiline_Bold' color='textStrong'>
            {title}
          </Title>
        </Header>
      )}
      <List>
        {items.map((item) => (
          <StyledPurchaseHistoryCard
            key={item.uniqueKey}
            brandName={item.brandName}
            productName={item.productName}
            imageUrl={item.imageUrl}
            optionItemName={item.optionItemName ?? undefined}
            actionButtonText={item.uniqueKey === selectedId ? selectedButtonText : actionButtonText}
            actionButtonVariant={item.uniqueKey === selectedId ? 'tertiary' : 'primary'}
            isSelected={item.uniqueKey === selectedId}
            onCompareClick={() => onCardClick(item, item.uniqueKey)}
            onProductClick={onProductClick ? () => onProductClick(item) : undefined}
            productInfoWidth={undefined}
          />
        ))}
      </List>
    </Container>
  );
};

const Container = styled.div<{ noPadding: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ noPadding }) => (noPadding ? '0' : '24px 20px 40px 20px')};
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
  padding: 0 4px;
`;

const Title = styled(Text)`
  text-align: center;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  flex: 1;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  > div {
    width: 100%;
    margin-right: 0;
  }
`;

const StyledPurchaseHistoryCard = styled(PurchaseHistoryCard)`
  border: none;
  padding: 0;
  width: 100%;
  max-width: none;
  margin-right: 0;
  height: 64px;
  flex-shrink: 0;
`;
